import {type TranslationObject} from '@colonist/i18n'
import {TimeUtils} from '../utils/TimeUtils.ts'
import {HTTPStatus} from './ErrorEnums.ts'
import {ErrorDefault} from './Errors.ts'

export namespace ErrorsRanked {

    export class NoAdBlockState extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.waitingForAdblockState'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class InvalidSeason extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.invalidSeason'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

    export class BetaSeasonsNotSaved extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.betaSeason'}
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class ServerErrorCitiesAndKnights extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.unableToEnterRankedCitiesAndKnights'}
            const httpStatus = HTTPStatus.InternalServerError
            super(title, message, httpStatus)
        }
    }

    export class NoAccessToCitiesAndKnights extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.noAccessToCitiesAndKnights'}
            const httpStatus = HTTPStatus.Unauthorized
            super(title, message, httpStatus)
        }
    }

    export class NoActiveSeason extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.noActiveSeason'}
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class NoNewSeasonAnnounced extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.noSeasonAnnounced'}
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    export class NextSeasonNotStarted extends ErrorDefault {
        constructor(nextSeasonStart: Date) {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {
                key: 'strings:popups.errors.rankedError.nextSeasonNotStarted',
                options: {
                    timeUntilNextSeason: `${TimeUtils.getDaysHoursMinutesBetweenDatesString(nextSeasonStart, new Date())}`,
                },
            }
            const httpStatus = HTTPStatus.ServiceUnavailable
            super(title, message, httpStatus)
        }
    }

    // Ideally we should replace this error with `ErrorsMustLogin.Generic()` but for socket msgs we still need this error for now.
    export class MustLogin extends ErrorDefault {
        constructor() {
            const title: TranslationObject = {key: 'strings:popups.errors.rankedError.title'}
            const message: TranslationObject = {key: 'strings:popups.errors.rankedError.logInForRanked'}
            const httpStatus = HTTPStatus.BadRequest
            super(title, message, httpStatus)
        }
    }

}
